import { milestones } from "@/mocks/content";

export default function MilestoneTimeline() {
  return (
    <section className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-2xl mb-10 md:mb-14">
        <p className="text-xs md:text-sm font-medium tracking-[0.3em] text-accent-700 mb-3">
          OUR JOURNEY
        </p>
        <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 font-heading">
          发展历程
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          从一间旧厂房工作室，到覆盖产品、空间与内容的完整品牌，每一步都值得被认真记录。
        </p>
      </div>

      <div className="relative pl-8 md:pl-0">
        <div className="absolute left-[7px] md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-1/2"></div>
        <div className="flex flex-col gap-10 md:gap-0">
          {milestones.map((m, index) => (
            <div
              key={m.year}
              className={`relative md:flex md:items-center md:gap-10 ${
                index % 2 === 1 ? "md:flex-row-reverse" : ""
              } md:py-6`}
            >
              <span className="absolute left-0 md:left-1/2 top-1 md:top-1/2 w-3.5 h-3.5 rounded-full bg-accent-500 border-4 border-background-50 md:-translate-x-1/2 md:-translate-y-1/2"></span>
              <div className="md:w-1/2">
                <div
                  className={`bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 ${
                    index % 2 === 1 ? "md:text-right md:ml-auto" : ""
                  } md:max-w-md`}
                >
                  <p className="text-xl font-heading font-semibold text-primary-600">{m.year}</p>
                  <h3 className="mt-1 text-base font-medium text-foreground-950">{m.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {m.description}
                  </p>
                </div>
              </div>
              <div className="hidden md:block md:w-1/2"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}